

export module MPCDebugController {

    export class DebugController {
        private scope: HTMLElement;
        private static _instance: DebugController;
        
        static get instance() {
            return this._instance || (this._instance = new this());
        }

        public init(scope: HTMLElement): void {
            this.scope = scope.querySelector('.grid');
            const highlightSourceButton: HTMLElement = this.scope.querySelector('.hightlight-source');

            if(highlightSourceButton)
                highlightSourceButton.addEventListener('click', () => { this.handleFlyoutIconClick(); });
        }

        handleFlyoutIconClick(): any {
            if (this.scope.classList.contains('debug-enabled'))
                this.scope.classList.remove('debug-enabled');
            else
                this.scope.classList.add('debug-enabled');
        }
    }
}